"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var operators_1 = require("rxjs/operators");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var of_1 = require("rxjs/observable/of");
var idm_um_permission_client_js_1 = require("@synisys/idm-um-permission-client-js");
var HttpRootCategoryProviderService = /** @class */ (function () {
    function HttpRootCategoryProviderService(kbService, deService, portfolioService) {
        this.kbService = kbService;
        this.deService = deService;
        this.portfolioService = portfolioService;
    }
    HttpRootCategoryProviderService.prototype.getRootCategoryMetaField = function (categoryId) {
        var _this = this;
        return this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(categoryId)).pipe(operators_1.switchMap(function (metaCategory) {
            if (metaCategory.getIsRoot) {
                return of_1.of(null);
            }
            else {
                return _this.kbService.getMetaFields(categoryId).pipe(operators_1.switchMap(function (fields) {
                    var parentMetaField = fields.find(function (value) { return value.getType() === idm_kb_service_client_js_1.MetaFieldType.PARENT; });
                    if (parentMetaField) {
                        return of_1.of(parentMetaField);
                    }
                    else {
                        return _this.kbService.getMainEntityMetaCategories()
                            .map(function (mainCategories) {
                            var rootCategories = Array.from(mainCategories)
                                .filter(function (mainCategory) { return mainCategory.getIsRoot; }).map(function (mainCategory) { return mainCategory.getSystemName(); });
                            return fields.find(function (field) {
                                return field.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY &&
                                    rootCategories.includes(field.getCompoundCategorySystemName());
                            });
                        });
                    }
                }));
            }
        }));
    };
    HttpRootCategoryProviderService.prototype.getRootCategoryId = function (categoryId) {
        var _this = this;
        return this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(categoryId)).pipe(operators_1.switchMap(function (metaCategory) {
            if (metaCategory.getIsRoot) {
                return of_1.of(categoryId);
            }
            else {
                return _this.getRootCategoryMetaField(categoryId).pipe(operators_1.map(function (metaField) { return metaField ? metaField.getCompoundCategorySystemName() : null; }));
            }
        }));
    };
    HttpRootCategoryProviderService.prototype.getRootEntityId = function (rootCategoryId, categoryId, entity) {
        if (entity) {
            if (rootCategoryId === categoryId) {
                return of_1.of(entity.getInstanceId());
            }
            return this.kbService.getMetaFields(categoryId).pipe(operators_1.map(function (fields) {
                var lookupToRootField = fields.find(function (field) { return field.getCompoundCategorySystemName() === rootCategoryId; });
                if (lookupToRootField) {
                    if (lookupToRootField.getType() === idm_kb_service_client_js_1.MetaFieldType.PARENT) {
                        return entity.getProperty(lookupToRootField.getSystemName()).value;
                    }
                    var rootEntity = entity.getProperty(lookupToRootField.getSystemName()).value;
                    return rootEntity ? +rootEntity.getInstanceId() : null;
                }
                return null;
            }));
        }
        return of_1.of(null);
    };
    HttpRootCategoryProviderService.prototype.getRootEntity = function (categoryId, entity) {
        var _this = this;
        return this.getRootCategoryId(categoryId).pipe(operators_1.switchMap(function (rootCategoryId) {
            if (rootCategoryId === categoryId) {
                return of_1.of(entity);
            }
            else {
                return _this.getRootEntityId(rootCategoryId, categoryId, entity).pipe(operators_1.switchMap(function (rootEntityId) { return _this.deService.loadEntityByInstanceId(rootCategoryId, rootEntityId); }));
            }
        }));
    };
    HttpRootCategoryProviderService.prototype.getChildCategories = function (rootCategoryId) {
        var _this = this;
        return this.kbService.getMainEntityMetaCategories().pipe(operators_1.switchMap(function (categories) {
            return Observable_1.Observable.zip.apply(Observable_1.Observable, Array.from(categories)
                .map(function (category) { return _this.getRootCategoryMetaField(category.getSystemName()).pipe(operators_1.map(function (lookup) {
                var isCompatibleLookUp = (lookup && lookup.getCompoundCategorySystemName() === rootCategoryId);
                return isCompatibleLookUp ? { category: category.getSystemName(), field: lookup.getSystemName() } : null;
            })); }));
        }), operators_1.map(function (categories) {
            var result = new Map();
            categories.forEach(function (value) { return value && value.field && result.set(value.category, value.field); });
            return result;
        }));
    };
    HttpRootCategoryProviderService.prototype.getSingleChildEntityId = function (rootCategoryId, rootEntityId, categoryId) {
        var _this = this;
        return this.kbService.getMetaFields(categoryId).pipe(operators_1.switchMap(function (fields) {
            var lookupToRootField = fields.find(function (field) { return field.getCompoundCategorySystemName() === rootCategoryId; });
            if (lookupToRootField) {
                var instanceMetaField = fields.find(function (field) { return field.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE; });
                var filters = new idm_de_core_frontend_1.FilterBuilder().is(lookupToRootField.getSystemName(), rootEntityId).build().toJson();
                var pagingOptions = new idm_de_core_frontend_1.PagingOptions(0, 1);
                return _this.portfolioService.loadEntitySearchItems(categoryId, [], instanceMetaField.getSystemName(), pagingOptions, null, filters, [idm_um_permission_client_js_1.CategoryPermissionType.VIEW])
                    .pipe(operators_1.map(function (data) {
                    return data.getData() && data.getData()[0] && data.getData()[0].id;
                }));
            }
            return Observable_1.Observable.of(null);
        }));
    };
    HttpRootCategoryProviderService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService, idm_de_service_client_js_1.DeService,
            idm_de_service_client_js_1.PortfolioService])
    ], HttpRootCategoryProviderService);
    return HttpRootCategoryProviderService;
}());
exports.HttpRootCategoryProviderService = HttpRootCategoryProviderService;
//# sourceMappingURL=http-root-category-provider.service.js.map